import FileSaver from 'file-saver'
import Vue from 'vue'
import moment from 'moment'
import { isProd } from './utils/common'

function processFileResponse(r, filename) {
  const contentType = r.headers.get('content-type')
  return new Blob([r.data], { type: `${contentType};charset=utf-8` })
}

function getFilename(r) {
  const contentDisposition = r.headers.get('content-disposition')
  const regx = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/i
  return decodeURIComponent((regx.exec(contentDisposition || '') || [])[3] || '')
   || `${moment().format('YYYY-MM-DD-HH-mm-ss')}.${getExt(r)}`
}

function getExt(r) {
  const contentType = r.headers.get('content-type')
  let ext = 'txt'
  if (contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    ext = 'xlsx'
  else if (contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
    ext = 'docx'
  return ext
}

export default {
  middleware: null,
  request(name, data) {
    if (this.middleware)
      data = this.middleware(data)
    const url = `system/templates/render/${name}`
    Vue.http.post(url, { payload: data }, { responseType: 'arraybuffer' })
      .then(r => {
        FileSaver.saveAs(processFileResponse(r), getFilename(r))
      })
      .catch(err => {
        if (!isProd) console.error(`[${url}] get error `, err)
      })
  },
  set_middleware(middleware) {
    this.middleware = middleware
  },
  download_template(name, display_name) {
    const url = `system/templates/download/${name}`
    Vue.http.get(url, { responseType: 'arraybuffer' })
      .then(r => {
        FileSaver.saveAs(processFileResponse(r), `${display_name || name}-模板-${moment().format('YYYY-MM-DD-HH-mm-ss')}.${getExt(r)}`)
      })
      .catch(err => {
        if (!isProd) console.error(`[${url}] get error `, err)
      })
  },
  upload_template(name, file) {
    // TODO:
  },
}



// WEBPACK FOOTER //
// ./client/src/templater_requester.js